import { render, staticRenderFns } from "./Ineligible.vue?vue&type=template&id=5a19c91f&scoped=true&"
import script from "./Ineligible.vue?vue&type=script&lang=ts&"
export * from "./Ineligible.vue?vue&type=script&lang=ts&"
import style0 from "./Ineligible.vue?vue&type=style&index=0&id=5a19c91f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a19c91f",
  null
  
)

export default component.exports